// extracted by mini-css-extract-plugin
export var core = "Hero-module--core--814b8";
export var image = "Hero-module--image--fecf6";
export var pretitle = "Hero-module--pretitle--9ed2d";
export var text = "Hero-module--text--c9f38";